import styled from 'styled-components';
import { tokens } from '@welbe/web-design-system';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	position: relative;
	background-color: ${tokens.color_white};
	padding: 3vh 2vw 10vh 2vw;
`;

export const Content = styled.div<{ width?: string }>`
	display: flex;
	flex-direction: column;
	height: 100%;
	gap: 30px;
	width: ${({ width }) => (width ? width : '900px')};

	padding-top: 50px;

	@media (max-width: 1000px) {
		width: ${({ width }) => (width ? width : '600px')};
	}
`;

export const Footer = styled.div`
	display: flex;
	flex-direction: row;
	gap: 30px;
	padding-right: 40px;
	justify-content: flex-end;
	align-items: center;
	height: 100px;

	background-color: ${tokens.color_gray_light};
`;

export const CardContainer = styled.div`
	display: flex;
	flex-direction: row;
	gap: 30px;
	padding-top: 20px;
	flex-wrap: wrap;
`;

export const SectionLogo = styled.div`
	position: absolute;
	top: -30px;
	left: 50%;
	transform: translateX(-50%);
	width: 60px;
	height: 60px;
	background-color: ${tokens.color_primary};
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;

	& > svg {
		display: grid;
		place-items: center;
		width: 36px;
		height: 36px;

		& > path {
			fill: #fff;
		}
	}
`;

export const SkeletonContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`;

export const CardItemContainer = styled.div`
	& div {
		background-color: ${tokens.color_gray_light};
		box-shadow: none;

		p:nth-child(1) {
			font-weight: 700;
		}
	}
`;
